import React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Write = function Write(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      d: "M22 20.3334C22 21.2539 21.2538 22.0001 20.3332 22.0001H3.66635C2.74585 22.0001 1.99963 21.2539 1.99963 20.3334V3.66623C1.99963 2.74573 2.74585 1.99951 3.66635 1.99951H20.3333C21.2538 1.99951 22 2.74573 22 3.66623V20.3334Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M9.13899 17.7738L5.33301 18.6667L6.22593 14.8614L15.4078 5.67779C15.8681 5.21808 16.6138 5.21808 17.0729 5.67779L18.3226 6.92624C18.7817 7.38654 18.7817 8.13114 18.3226 8.59143L9.13899 17.7738Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M9.28681 17.6257L6.37317 14.7114",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};
Write.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Write };
var Stats = function Stats(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5",
      d: "M1.50011 14.0479l3.52849 1.5047 2.73917-3.6078 3.69913 5.3419 2.464-5.4812 2.7392 4.6141 3.8335-10.09538"
    }), /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinejoin: "round",
      strokeWidth: "1.5",
      d: "M25.4998 23c0 1.1046-.8954 2-2 2H3.50012c-1.10457 0-2-.8954-2-2V3c0-1.10457.89543-2 2-2H23.4999c1.1045 0 1.9999.89543 1.9999 2v20z",
      clipRule: "evenodd"
    })]
  });
};
Stats.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 27 26",
  width: "1em",
  height: "1em"
};
export { Stats };
var Contacts = function Contacts(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      d: "M21.9999 20.3333C21.9999 21.2538 21.2538 22 20.3333 22H3.66667C2.74619 22 2 21.2538 2 20.3333V3.66667C2 2.74619 2.74619 2 3.66667 2H20.3333C21.2538 2 21.9999 2.74619 21.9999 3.66667V20.3333Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M12.0366 12.1665V12.4708L14.2435 13.1022C14.7035 13.2334 15.0801 13.7318 15.0801 14.21V16.8187H6.3844V14.21C6.3844 13.7318 6.76092 13.2334 7.22005 13.1022L9.42787 12.4708V12.1665",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M13.3405 8.79356C13.3405 10.3658 12.1717 11.6379 10.7317 11.6379C9.29087 11.6379 8.12305 10.3658 8.12305 8.79356C8.12305 7.22313 9.29087 5.94922 10.7317 5.94922C12.1717 5.94922 13.3405 7.22313 13.3405 8.79356Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M19 17H22V20C22 21.1 21.1 22 20 22H19M19 2H20C21.1 2 22 2.89999 22 3.99999V6.99997H19V2ZM19 7H22V12H19V7ZM19 12H22V17H19V12Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M19 2V21.5821",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};
Contacts.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Contacts };
var ListMenu = function ListMenu(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      d: "M22.25 6.25H8.75V1.75H20C21.2426 1.75 22.25 2.75736 22.25 4V6.25Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M22.25 14.25H8.75V9.75H22.25V14.25Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M20 22.25H8.75V17.75H22.25V20C22.25 21.2426 21.2426 22.25 20 22.25Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "4",
      cy: "4",
      r: "2.25",
      stroke: "currentColor",
      strokeWidth: "1.5"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "4",
      cy: "12",
      r: "2.25",
      stroke: "currentColor",
      strokeWidth: "1.5"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "4",
      cy: "20",
      r: "2.25",
      stroke: "currentColor",
      strokeWidth: "1.5"
    })]
  });
};
ListMenu.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { ListMenu };
var Form = function Form(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22 10H2V2H22V10Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22 18C22 20.2091 20.2091 22 18 22H6C3.79086 22 2 20.2091 2 18V18C2 15.7909 3.79086 14 6 14H18C20.2091 14 22 15.7909 22 18V18Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("line", {
      x1: "4.75",
      y1: "4",
      x2: "4.75",
      y2: "8",
      stroke: "currentColor",
      strokeWidth: "1.5"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "10",
      cy: "18",
      r: "1.5",
      stroke: "currentColor"
    }), /*#__PURE__*/_jsx("line", {
      x1: "13",
      y1: "16",
      x2: "13",
      y2: "20",
      stroke: "currentColor"
    }), /*#__PURE__*/_jsx("line", {
      x1: "13.1464",
      y1: "18.6464",
      x2: "14.9849",
      y2: "16.808",
      stroke: "currentColor"
    }), /*#__PURE__*/_jsx("line", {
      x1: "13.4535",
      y1: "17.6464",
      x2: "15.5041",
      y2: "19.6971",
      stroke: "currentColor"
    })]
  });
};
Form.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Form };
var Automate = function Automate(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      d: "M13.4815 4.60889H4.66667C3.19378 4.60889 2 5.77671 2 7.21759V16.7828C2 18.2228 3.19378 19.3915 4.66667 19.3915H6.16667",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M9.66669 19.3915H19.3334C20.8054 19.3915 22 18.2228 22 16.7828V7.21759C22 5.77671 20.8054 4.60889 19.3334 4.60889H17.8332",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M12.5554 2L14.3332 4.6087L12.5554 7.2174",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M11.4445 16.7827L9.66669 19.3914L11.4445 22.0001",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};
Automate.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Automate };
var Plane = function Plane(props) {
  return /*#__PURE__*/_jsx("svg", {
    ...props,
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.1868 18.9381L24 5L0 12.3733L9.19636 14.2691L9.23929 19L11.9982 16.4711L9.85119 14.4652L17.1868 18.9381Z",
      fill: "currentColor"
    })
  });
};
Plane.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Plane };
var PlaneOutline = function PlaneOutline(props) {
  return /*#__PURE__*/_jsx("svg", {
    ...props,
    children: /*#__PURE__*/_jsx("path", {
      d: "M15.9009 18.5629C16.0852 18.6881 16.3157 18.7249 16.5298 18.6632C16.744 18.6016 16.9196 18.4479 17.0092 18.2438L22.6868 5.3013C22.8064 5.02877 22.7535 4.71133 22.552 4.49229C22.3506 4.27325 22.0386 4.19404 21.7571 4.29043L1.75709 11.1371C1.44015 11.2456 1.2336 11.5511 1.25101 11.8856C1.26843 12.2202 1.5056 12.5026 1.83209 12.5776L8.91848 14.2054L8.94944 18.0061C8.95192 18.3098 9.13727 18.582 9.41891 18.6956C9.70054 18.8091 10.0229 18.7417 10.2353 18.5247L12.4761 16.236L15.9009 18.5629Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};
PlaneOutline.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { PlaneOutline };
var Plus = function Plus(props) {
  return /*#__PURE__*/_jsx("svg", {
    ...props,
    children: /*#__PURE__*/_jsx("path", {
      d: "M12 21V3M21 12H3H21Z",
      stroke: "currentColor",
      strokeWidth: "3",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};
Plus.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Plus };
var PlusBold = function PlusBold(props) {
  return /*#__PURE__*/_jsx("svg", {
    ...props,
    children: /*#__PURE__*/_jsx("path", {
      d: "M20.8407 12L3.1593 12M12 3.15932L12 20.8407L12 3.15932Z",
      stroke: "currentColor",
      strokeWidth: "3",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};
PlusBold.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { PlusBold };
var Email = function Email(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.9128 11.9995C15.9128 14.1612 14.1606 15.9126 11.9997 15.9126C9.8389 15.9126 8.08673 14.1612 8.08673 11.9995C8.08673 9.8386 9.8389 8.08643 11.9997 8.08643C14.1606 8.08643 15.9128 9.8386 15.9128 11.9995Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M17.6522 20.2609C16.0435 21.3652 14.0974 22 12 22C6.47652 22 2 17.5235 2 12C2 6.47739 6.47652 2 12 2C17.5235 2 22 6.47739 22 12V12.8695C22 14.5513 20.6374 15.913 18.9565 15.913C17.2756 15.913 15.913 14.5513 15.913 12.8695V12",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};
Email.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Email };
var More = function More(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      d: "M4.79999 14.2001C5.7941 14.2001 6.59999 13.3942 6.59999 12.4001C6.59999 11.406 5.7941 10.6001 4.79999 10.6001C3.80588 10.6001 3 11.406 3 12.4001C3 13.3942 3.80588 14.2001 4.79999 14.2001Z",
      fill: "currentColor"
    }), /*#__PURE__*/_jsx("path", {
      d: "M12.0003 14.2001C12.9944 14.2001 13.8003 13.3942 13.8003 12.4001C13.8003 11.406 12.9944 10.6001 12.0003 10.6001C11.0062 10.6001 10.2003 11.406 10.2003 12.4001C10.2003 13.3942 11.0062 14.2001 12.0003 14.2001Z",
      fill: "currentColor"
    }), /*#__PURE__*/_jsx("path", {
      d: "M19.2 14.2001C20.1941 14.2001 21 13.3942 21 12.4001C21 11.406 20.1941 10.6001 19.2 10.6001C18.2059 10.6001 17.4 11.406 17.4 12.4001C17.4 13.3942 18.2059 14.2001 19.2 14.2001Z",
      fill: "currentColor"
    })]
  });
};
More.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { More };
var Location = function Location(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.3478 8.52174C18.3478 12.1252 11.8261 22 11.8261 22C11.8261 22 5.30432 12.1252 5.30432 8.52174C5.30432 4.92 8.22345 2 11.8261 2C15.4278 2 18.3478 4.92 18.3478 8.52174Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.4348 8.52178C14.4348 9.96265 13.2661 11.1305 11.8261 11.1305C10.3852 11.1305 9.21741 9.96265 9.21741 8.52178C9.21741 7.08178 10.3852 5.91309 11.8261 5.91309C13.2661 5.91309 14.4348 7.08178 14.4348 8.52178Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};
Location.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Location };
var Sms = function Sms(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22 10.9013C22 15.4858 17.4447 19.204 11.824 19.204C10.5693 19.204 9.36853 19.0182 8.25891 18.6793L2.41083 21.4012L4.70086 16.8299C2.81609 15.3239 1.64807 13.2232 1.64807 10.9013C1.64807 6.31596 6.20336 2.59863 11.824 2.59863C17.4447 2.59863 22 6.31596 22 10.9013V10.9013Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.84216 11.005C8.84216 11.7368 8.24753 12.3323 7.51486 12.3323C6.78219 12.3323 6.18756 11.7368 6.18756 11.005C6.18756 10.2715 6.78219 9.67773 7.51486 9.67773C8.24753 9.67773 8.84216 10.2715 8.84216 11.005V11.005Z",
      fill: "currentColor"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.1514 11.005C13.1514 11.7368 12.5567 12.3323 11.8241 12.3323C11.0914 12.3323 10.4968 11.7368 10.4968 11.005C10.4968 10.2715 11.0914 9.67773 11.8241 9.67773C12.5567 9.67773 13.1514 10.2715 13.1514 11.005V11.005Z",
      fill: "currentColor"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.4605 11.005C17.4605 11.7368 16.8659 12.3323 16.1332 12.3323C15.4005 12.3323 14.8059 11.7368 14.8059 11.005C14.8059 10.2715 15.4005 9.67773 16.1332 9.67773C16.8659 9.67773 17.4605 10.2715 17.4605 11.005V11.005Z",
      fill: "currentColor"
    })]
  });
};
Sms.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Sms };
var Pen = function Pen(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      d: "M7.70873 20.6604L2 21.9997L3.33933 16.2919L17.1115 2.51715C17.8019 1.82762 18.9205 1.82762 19.6092 2.51715L21.4835 4.38975C22.1722 5.08017 22.1722 6.19702 21.4835 6.88743L7.70873 20.6604Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M7.9312 20.4395L3.56091 16.0684",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};
Pen.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Pen };
var Phone = function Phone(props) {
  return /*#__PURE__*/_jsx("svg", {
    ...props,
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.3513 7.8205C10.1713 6.99865 10.1713 5.66858 9.3513 4.84763L7.12029 2.61571C6.29934 1.79476 4.96746 1.79476 4.1456 2.61571L2.92373 3.83941C1.86186 4.90127 1.6973 6.5559 2.52462 7.80868C6.07842 13.1807 10.8195 17.9219 16.1925 21.4766C17.4425 22.3021 19.1035 22.1376 20.1618 21.0784L21.3846 19.8547C22.2065 19.0337 22.2065 17.7018 21.3846 16.8818L19.1544 14.6518C18.3344 13.829 17.0025 13.829 16.1807 14.6518L15.437 15.3955C12.9914 13.3908 10.6113 11.0098 8.60763 8.56326L9.3513 7.8205Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};
Phone.defaultProps = {
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Phone };
var Search = function Search(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      d: "M15.5001 9.30008C15.5001 12.8001 12.7001 15.6002 9.20007 15.6002C5.80003 15.5001 3 12.7001 3 9.30008C3 5.80003 5.80003 3 9.30007 3C12.7001 3 15.5001 5.80003 15.5001 9.30008Z",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M13.7001 13.7002L21.0002 21.0003",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};
Search.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Search };
var Settings = function Settings(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      d: "M7.273 20.0009L8.68752 18.5851C8.92764 18.6877 9.17957 18.7763 9.41829 18.8523C9.64049 18.923 9.86452 18.9868 10.0761 19.0433V21C10.0761 21.4142 10.4119 21.75 10.8261 21.75H13.1739C13.5881 21.75 13.9239 21.4142 13.9239 21V19.0434C14.1354 18.9869 14.3593 18.9231 14.5813 18.8526C14.8197 18.7768 15.0713 18.6884 15.3111 18.5862L16.7275 20.0013C17.0204 20.294 17.4951 20.2939 17.7879 20.0011L20.0011 17.7879C20.294 17.495 20.294 17.0203 20.0012 16.7274L18.5862 15.3117C18.6884 15.0718 18.7768 14.8201 18.8526 14.5816C18.9232 14.3595 18.9869 14.1355 19.0434 13.9239H21C21.4142 13.9239 21.75 13.5881 21.75 13.1739V10.8261C21.75 10.4119 21.4142 10.0761 21 10.0761H19.043C18.9867 9.86461 18.923 9.64077 18.8525 9.41875C18.7767 9.17994 18.6883 8.92803 18.5861 8.68798L20.001 7.27366C20.1417 7.13302 20.2208 6.94224 20.2208 6.7433C20.2208 6.54436 20.1418 6.35356 20.0011 6.21289L17.7871 3.99889C17.4943 3.70604 17.0195 3.70599 16.7266 3.99877L15.3105 5.41418C15.0708 5.31214 14.8193 5.22387 14.5808 5.14814C14.3589 5.07771 14.1353 5.01413 13.9239 4.95777V3C13.9239 2.58579 13.5881 2.25 13.1739 2.25H10.8261C10.4119 2.25 10.0761 2.58579 10.0761 3V4.95773C9.86466 5.0141 9.64088 5.07768 9.41895 5.14811C9.1803 5.22385 8.92855 5.31213 8.6887 5.41421L7.27265 3.99877C6.97974 3.70599 6.50495 3.70604 6.2121 3.99889L3.9981 6.21289C3.85743 6.35356 3.77841 6.54436 3.77843 6.7433C3.77846 6.94224 3.85752 7.13302 3.99822 7.27366L5.41381 8.68864C5.3116 8.92846 5.22323 9.18014 5.14743 9.41864C5.07685 9.64069 5.01313 9.8646 4.95663 10.0761H3C2.58579 10.0761 2.25 10.4119 2.25 10.8261V13.1739C2.25 13.5881 2.58579 13.9239 3 13.9239H4.9566C5.01311 14.1355 5.07683 14.3595 5.14741 14.5816C5.22318 14.8201 5.31154 15.0718 5.41377 15.3116L3.9981 16.7272C3.85744 16.8679 3.77842 17.0587 3.77843 17.2576C3.77845 17.4566 3.85751 17.6473 3.9982 17.788L6.2122 20.0012C6.3529 20.1419 6.54372 20.2208 6.74266 20.2208C6.94161 20.2207 7.13238 20.1416 7.273 20.0009Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.9131 12C15.9131 14.1617 14.1609 15.913 12 15.913C9.83915 15.913 8.08698 14.1617 8.08698 12C8.08698 9.83909 9.83915 8.08691 12 8.08691C14.1609 8.08691 15.9131 9.83909 15.9131 12V12Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};
Settings.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Settings };
var Filter = function Filter(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      d: "M24.9999 13H9.771",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M24.9999 4H20.6626",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M11.8915 22H1",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M24.9996 22H16.2285",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M16.3252 4H1",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M5.33733 13H1",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M18.3252 7C17.2206 7 16.3252 6.10457 16.3252 5V3C16.3252 1.89543 17.2206 1 18.3252 1H18.6625C19.7671 1 20.6625 1.89543 20.6625 3V5C20.6625 6.10457 19.7671 7 18.6625 7H18.3252Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M7.3374 16C6.23283 16 5.3374 15.1046 5.3374 14V12C5.3374 10.8954 6.23283 10 7.3374 10H7.67473C8.7793 10 9.67473 10.8954 9.67473 12V14C9.67473 15.1046 8.7793 16 7.67473 16H7.3374Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M13.8911 25C12.7865 25 11.8911 24.1046 11.8911 23V21C11.8911 19.8954 12.7865 19 13.8911 19H14.2284C15.333 19 16.2284 19.8954 16.2284 21V23C16.2284 24.1046 15.333 25 14.2284 25H13.8911Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};
Filter.defaultProps = {
  width: "26",
  height: "26",
  viewBox: "0 0 26 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Filter };
var Warning = function Warning(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      d: "M12 14V10",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22 22H2L12 2L22 22Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.4542 18.2881C12.4542 18.539 12.2505 18.7426 11.9997 18.7426C11.7488 18.7426 11.5451 18.539 11.5451 18.2881C11.5451 18.0372 11.7488 17.8335 11.9997 17.8335C12.2505 17.8335 12.4542 18.0372 12.4542 18.2881Z",
      fill: "currentColor",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};
Warning.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Warning };
var Stop = function Stop(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      d: "M12 13V8",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 22L2 12L12 2L22 12L12 22Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.455 16.6211C12.455 16.8719 12.2513 17.0756 12.0004 17.0756C11.7495 17.0756 11.5459 16.8719 11.5459 16.6211C11.5459 16.3702 11.7495 16.1665 12.0004 16.1665C12.2513 16.1665 12.455 16.3702 12.455 16.6211Z",
      fill: "currentColor",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};
Stop.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Stop };
var PlusCircle = function PlusCircle(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M25 13C25 19.6262 19.6273 25 13 25C6.37273 25 1 19.6262 1 13C1 6.37164 6.37273 1 13 1C19.6273 1 25 6.37164 25 13V13Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M13 6.45459V19.5455",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M19.5455 13H6.45459",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};
PlusCircle.defaultProps = {
  width: "26",
  height: "26",
  viewBox: "0 0 26 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { PlusCircle };
var CloseCircle = function CloseCircle(props) {
  return /*#__PURE__*/_jsx("svg", {
    ...props,
    children: /*#__PURE__*/_jsx("g", {
      fill: "none",
      fillRule: "evenodd",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5",
      children: /*#__PURE__*/_jsx("path", {
        d: "M25 13.029437c0 6.6262-5.3727 12-12 12-6.62727 0-12-5.3738-12-12 0-6.62836 5.37273-12 12-12 6.6273 0 12 5.37164 12 12h0zM17.6283488 8.40111456L8.37167756 17.6577858M17.6284124 17.6577858L8.3717412 8.40111456"
      })
    })
  });
};
CloseCircle.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  width: "1em",
  height: "1em"
};
export { CloseCircle };
var Close = function Close(props) {
  return /*#__PURE__*/_jsx("svg", {
    ...props,
    children: /*#__PURE__*/_jsx("path", {
      d: "M21 21L3 3M21 3L3 21L21 3Z",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};
Close.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Close };
var CloseBold = function CloseBold(props) {
  return /*#__PURE__*/_jsx("svg", {
    ...props,
    children: /*#__PURE__*/_jsx("path", {
      d: "M20 20L4 4M20 4L4 20L20 4Z",
      stroke: "currentColor",
      strokeWidth: "3.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};
CloseBold.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { CloseBold };
var Minus = function Minus(props) {
  return /*#__PURE__*/_jsx("svg", {
    ...props,
    children: /*#__PURE__*/_jsx("path", {
      d: "M21 12H3",
      stroke: "currentColor",
      strokeWidth: "3",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};
Minus.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Minus };
var MinusBold = function MinusBold(props) {
  return /*#__PURE__*/_jsx("svg", {
    ...props,
    children: /*#__PURE__*/_jsx("path", {
      d: "M21 12H3",
      stroke: "currentColor",
      strokeWidth: "3.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};
MinusBold.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { MinusBold };
var Chevron = function Chevron(props) {
  return /*#__PURE__*/_jsx("svg", {
    ...props,
    children: /*#__PURE__*/_jsx("path", {
      d: "M7 2L17 12L7 22",
      stroke: "currentColor",
      strokeWidth: "3",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};
Chevron.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Chevron };
var ChevronLeft = function ChevronLeft(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("g", {
      clipPath: "url(#clip0_9738_13331)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M17 22L7 12L17 2",
        stroke: "currentColor",
        strokeWidth: "3",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_9738_13331",
        children: /*#__PURE__*/_jsx("rect", {
          width: "24",
          height: "24",
          fill: "currentColor",
          transform: "translate(24 24) rotate(-180)"
        })
      })
    })]
  });
};
ChevronLeft.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { ChevronLeft };
var ChevronDown = function ChevronDown(props) {
  return /*#__PURE__*/_jsx("svg", {
    ...props,
    children: /*#__PURE__*/_jsx("path", {
      d: "M22 7.7998L12 15.7998L2 7.7998",
      stroke: "currentColor",
      strokeWidth: "3",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};
ChevronDown.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { ChevronDown };
var ChevronUp = function ChevronUp(props) {
  return /*#__PURE__*/_jsx("svg", {
    ...props,
    children: /*#__PURE__*/_jsx("path", {
      d: "M2 16L12 8L22 16",
      stroke: "currentColor",
      strokeWidth: "3",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};
ChevronUp.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { ChevronUp };
var Arrow = function Arrow(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      d: "M17.6521 7.86963L21.9999 12.2175L17.6521 16.5653",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M22 12.2173H2",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};
Arrow.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Arrow };
var Checkmark = function Checkmark(props) {
  return /*#__PURE__*/_jsx("svg", {
    ...props,
    children: /*#__PURE__*/_jsx("path", {
      d: "M3 11.8044L9.09023 17.8947L21 5.98486",
      stroke: "currentColor",
      strokeWidth: "3",
      strokeMiterlimit: "10",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};
Checkmark.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Checkmark };
var Website = function Website(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22 11.9617C22 17.5052 17.5105 22 11.9722 22C6.43478 22 2 17.3261 2 11.7817C2 6.38435 6.23391 2.22435 11.5705 2.00956C11.7139 2.00261 11.8591 2 12.0044 2C17.5417 2 22 6.41826 22 11.9617Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M11.5695 2.00928C6.35209 7.66146 6.35209 15.0353 11.5695 21.9919",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M12.439 2.00928C17.6564 7.66145 17.6564 15.0336 12.439 21.9901",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M3.30438 16.7637H20.7496",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M3.65759 6.32812H20.2333",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M2 11.5459H21.9452",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};
Website.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Website };
var Tags = function Tags(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21.2932 13.9155C21.6836 14.306 21.6835 14.9391 21.293 15.3295L15.3288 21.293C14.9383 21.6835 14.3052 21.6835 13.9147 21.293L2.29951 9.67947C2.11217 9.49216 2.00682 9.23817 2.00657 8.97325L2.00094 3.00094C2.00042 2.44829 2.44829 2 3.00094 2H8.96997C9.23528 2 9.48972 2.10543 9.67727 2.29309L21.2932 13.9155Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.92022 7.18151C8.92022 8.14151 8.14196 8.92064 7.18109 8.92064C6.22109 8.92064 5.44196 8.14151 5.44196 7.18151C5.44196 6.22151 6.22109 5.44238 7.18109 5.44238C8.14196 5.44238 8.92022 6.22151 8.92022 7.18151Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};
Tags.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Tags };
var Bold = function Bold(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      d: "M5.52936 2V22",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M5.52942 11.5652H13.1765C16.7494 11.5652 19.6471 9.42436 19.6471 6.78262C19.6471 4.14174 16.7494 2 13.1765 2H2",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M10.8235 11.5654H14.9412C18.8377 11.5654 22 13.902 22 16.7828C22 19.6637 18.8377 22.0002 14.9412 22.0002H2",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};
Bold.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Bold };
var Italics = function Italics(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      d: "M18.5217 2L5.47827 21.1667",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M2 21.1665H8.95652",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M15.0435 2H22",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};
Italics.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Italics };
var Left = function Left(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      d: "M2 21.0908H22",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M2 2H19.3913",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M2 4.72705H15.913",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M2 7.45459H17.6522",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M2 10.1821H22",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M2 12.9092H18.5217",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M2 15.6367H15.913",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M2 18.3633H18.5217",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};
Left.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Left };
var Center = function Center(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      d: "M2 21.0908H22",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M3.73938 2H20.2611",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M6.78259 4.72754H17.2174",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M4.60809 7.45459H19.3907",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M2 10.1821H22",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M5.47791 12.9092H18.5214",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M7.6524 15.6367H16.3481",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M5.47791 18.3633H18.5214",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};
Center.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Center };
var Right = function Right(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      d: "M2 21.0908H21.9997",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M5.47791 2H21.9994",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M8.0871 4.72754H21.9999",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M5.47791 7.45459H21.9994",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M2 10.1821H21.9997",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M5.47791 12.9092H21.9994",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M8.0871 15.6367H21.9999",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M5.47791 18.3633H21.9994",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};
Right.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Right };
var Justified = function Justified(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      d: "M2 21.0908H16.7826",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M2 2H22",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M2 4.72754H22",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M2 7.45459H22",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M2 10.1816H22",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M2 12.9092H22",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M2 15.6367H22",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M2 18.3638H22",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};
Justified.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Justified };
var List = function List(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.33333 3.67628C5.33333 4.60159 4.58667 5.35257 3.66667 5.35257C2.745 5.35257 2 4.60159 2 3.67628C2 2.75098 2.745 2 3.66667 2C4.58667 2 5.33333 2.75098 5.33333 3.67628V3.67628Z",
      fill: "currentColor"
    }), /*#__PURE__*/_jsx("path", {
      d: "M9.01697 4.00537H22.0001",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.33333 12C5.33333 12.9253 4.58667 13.6763 3.66667 13.6763C2.745 13.6763 2 12.9253 2 12C2 11.0747 2.745 10.3237 3.66667 10.3237C4.58667 10.3237 5.33333 11.0747 5.33333 12V12Z",
      fill: "currentColor"
    }), /*#__PURE__*/_jsx("path", {
      d: "M9.01697 12.3296H22.0001",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.33333 20.3237C5.33333 21.2491 4.58667 22 3.66667 22C2.745 22 2 21.2491 2 20.3237C2 19.3984 2.745 18.6475 3.66667 18.6475C4.58667 18.6475 5.33333 19.3984 5.33333 20.3237V20.3237Z",
      fill: "currentColor"
    }), /*#__PURE__*/_jsx("path", {
      d: "M9.01697 20.6523H22.0001",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};
List.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { List };
var ListNumbered = function ListNumbered(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      d: "M7.21777 3.9834H22",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M7.21777 12.2197H22",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M7.21777 20.4556H22",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M3.66665 6.16662V2L2 3.55333",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M4.5001 14.5001H2.00012C3.78841 12.3878 4.41672 12.561 4.41672 11.3707C4.41672 10.7877 3.8742 10.3335 3.20842 10.3335C2.54023 10.3335 2.04241 10.7792 2.04241 11.3612",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M2.00012 18.6665H4.5001L3.20544 20.1303C4.27483 20.1303 4.5001 20.5893 4.5001 21.0655C4.5001 21.5417 4.27483 21.9998 3.20544 21.9998H2.00012",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};
ListNumbered.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { ListNumbered };
var Lowercase = function Lowercase(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      d: "M2 4.85714V2H14.1739V4.85714",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M8.08698 2V21.0476",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M5.91321 21.0479H10.261",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M13.3046 11.5718V9.66699H22.0002V11.5718",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M17.6523 10V21.0477",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M16.3478 21.0479H18.9565",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};
Lowercase.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Lowercase };
var Strikethrough = function Strikethrough(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      d: "M14.6089 6.09091V5.18182C14.6089 2.67091 12.661 2 10.261 2C7.85755 2 5.91321 3.12545 5.91321 5.63636C5.91321 11.0909 15.4784 11.5455 15.4784 17.4545C15.4784 20.4664 13.1402 22 10.261 22C7.37842 22 5.04364 20.9209 5.04364 17.9091V17",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M2 12.9092H22",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};
Strikethrough.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Strikethrough };
var Underscore = function Underscore(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      d: "M2 21.1665H22",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M5.47827 2V11.5833C5.47827 15.035 8.3974 17.8333 12 17.8333C15.6017 17.8333 18.5217 15.035 18.5217 11.5833V2",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M2.86957 2H8.08696",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M15.9131 2H21.1305",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};
Underscore.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Underscore };
var Uppercase = function Uppercase(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      d: "M2 4.66667V2H10.6957V4.66667",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M6.3479 2V20.6667",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M5.04364 20.6665H7.65234",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M13.3044 4.66667V2H22V4.66667",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M17.6521 2V20.6667",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M16.3477 20.6665H18.9564",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};
Uppercase.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Uppercase };
var Column1 = function Column1(props) {
  return /*#__PURE__*/_jsx("svg", {
    ...props,
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22 22H2V2H22V22Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};
Column1.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Column1 };
var Column2 = function Column2(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22 22H2V2H22V22Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M11.9995 2V22",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinejoin: "round"
    })]
  });
};
Column2.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Column2 };
var Column3 = function Column3(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22 22H2V2H22V22Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M8.36316 2V22",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M15.6359 2V22",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinejoin: "round"
    })]
  });
};
Column3.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Column3 };
var Column4 = function Column4(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22 22H2V2H22V22Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M6.69647 2V22",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M17.3027 2V22",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M12 2V22",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinejoin: "round"
    })]
  });
};
Column4.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Column4 };
var Column31 = function Column31(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M25 25H1V1H25V25Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M19.3633 1V25",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinejoin: "round"
    })]
  });
};
Column31.defaultProps = {
  width: "26",
  height: "26",
  viewBox: "0 0 26 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Column31 };
var Column13 = function Column13(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M25 25H1V1H25V25Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M6.63574 1V25",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinejoin: "round"
    })]
  });
};
Column13.defaultProps = {
  width: "26",
  height: "26",
  viewBox: "0 0 26 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Column13 };
var Column21 = function Column21(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M25 25H1V1H25V25Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M17.363 1V25",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinejoin: "round"
    })]
  });
};
Column21.defaultProps = {
  width: "26",
  height: "26",
  viewBox: "0 0 26 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Column21 };
var Column12 = function Column12(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M25 25H1V1H25V25Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M8.63574 1V25",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinejoin: "round"
    })]
  });
};
Column12.defaultProps = {
  width: "26",
  height: "26",
  viewBox: "0 0 26 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Column12 };
var Divider = function Divider(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      d: "M22 14.1738H2",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M22 10.6958H2",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M11.5652 21.9999V14.1738",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M11.5652 10.6954V2.43457",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M8.95654 19.3916L11.5652 22.0003L14.1739 19.3916",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M8.95654 4.6087L11.5652 2L14.1739 4.6087",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};
Divider.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Divider };
var Image = function Image(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22.0002 22H2.00024V2H22.0002V22Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M22 16.7827H2",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.82613 4.6084C8.74352 4.6084 7.85222 5.40318 7.687 6.43796C7.54004 6.38144 7.38352 6.34753 7.21743 6.34753C6.49743 6.34753 5.91309 6.93188 5.91309 7.65188C5.91309 8.37188 6.49743 8.95622 7.21743 8.95622H9.82613C11.027 8.95622 12 7.98318 12 6.78231C12 5.58144 11.027 4.6084 9.82613 4.6084V4.6084Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M4.60876 16.7827C4.60876 16.7827 6.3479 12.4349 8.52181 12.4349C10.6957 12.4349 12.4349 15.0436 12.4349 15.0436L15.0566 10.5497C15.3175 10.101 15.7975 9.82617 16.3157 9.82617C16.8688 9.82617 17.374 10.1383 17.6201 10.6331L20.6957 16.7827",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};
Image.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Image };
var Images = function Images(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      d: "M25 6.21738V23C25 24.1046 24.1046 25 23 25H6.21741",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M22.913 3.08694V20.913C22.913 22.0176 22.0176 22.913 20.913 22.913H3.08691",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20.8263 18.8261C20.8263 19.9307 19.9309 20.8261 18.8263 20.8261H3.00024C1.89567 20.8261 1.00024 19.9307 1.00024 18.8261V3C1.00024 1.89543 1.89567 1 3.00024 1H18.8263C19.9309 1 20.8263 1.89543 20.8263 3V18.8261Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M18.2174 16.6522L15.087 8.30435L10.9131 14.5652L8.30438 11.4348L5.17395 16.6522",
      stroke: "currentColor",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.30438 5.69565C8.30438 6.55965 7.60421 7.26087 6.73917 7.26087C5.87517 7.26087 5.17395 6.55965 5.17395 5.69565C5.17395 4.83165 5.87517 4.13043 6.73917 4.13043C7.60421 4.13043 8.30438 4.83165 8.30438 5.69565V5.69565Z",
      stroke: "currentColor",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M20.8261 16.6522H1",
      stroke: "currentColor",
      strokeLinejoin: "round"
    })]
  });
};
Images.defaultProps = {
  width: "26",
  height: "26",
  viewBox: "0 0 26 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Images };
var Button = function Button(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.3482 8.52163C10.3482 7.80946 10.9395 7.21729 11.6526 7.21729C12.3726 7.21729 12.9569 7.80163 12.9569 8.52163V13.739L16.87 15.0434C17.7291 15.3199 17.9421 16.3364 17.7395 17.2173L16.87 21.9999H9.91346L6.4352 16.7825C6.04042 16.1799 6.00042 15.0434 6.86998 15.0434C7.73955 15.0434 8.60911 15.4077 10.3482 18.0868V8.52163V8.52163Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M7.38752 12.4348H4.72211C3.2186 12.4348 2 11.2669 2 9.82608V4.60869C2 3.16782 3.2186 2 4.72211 2L19.2779 2C20.7805 2 22 3.16782 22 4.60869V9.82608C22 11.2669 20.7805 12.4348 19.2779 12.4348H16.4612",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinejoin: "round"
    })]
  });
};
Button.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Button };
var Text = function Text(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      d: "M3.63679 17.8616L4.93368 14.2102H10.1464L11.4433 17.8616H13.0802L8.34589 4.96826H6.73422L1.99994 17.8616H3.63679ZM5.42474 12.8252L7.48969 7.00803H7.59042L9.65537 12.8252H5.42474Z",
      fill: "currentColor"
    }), /*#__PURE__*/_jsx("path", {
      d: "M17.5679 18.0885C19.2551 18.0885 20.1365 17.1819 20.4387 16.5524H20.5143V17.8618H22V11.4907C22 8.41847 19.6581 8.06592 18.4241 8.06592C16.9636 8.06592 15.3015 8.56956 14.546 10.3323L15.9563 10.836C16.2836 10.1309 17.058 9.3754 18.4745 9.3754C19.8406 9.3754 20.5143 10.0994 20.5143 11.3396V11.39C20.5143 12.1077 19.784 12.0447 18.0212 12.2714C16.227 12.5043 14.269 12.9009 14.269 15.117C14.269 17.0056 15.7296 18.0885 17.5679 18.0885ZM17.7946 16.7538C16.611 16.7538 15.7548 16.225 15.7548 15.1925C15.7548 14.0593 16.7873 13.7068 17.9457 13.5557C18.5752 13.4801 20.2624 13.3038 20.5143 13.0017V14.3615C20.5143 15.5703 19.5573 16.7538 17.7946 16.7538Z",
      fill: "currentColor"
    })]
  });
};
Text.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Text };
var Link = function Link(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      d: "M14.438 12.4876L14.5219 12.5715C15.2836 13.3332 16.5183 13.3332 17.28 12.5715L21.1471 8.70542C22.2843 7.56725 22.2843 5.7054 21.1471 4.56723L19.4325 2.85363C18.2953 1.71546 16.4325 1.71546 15.2953 2.85363L11.4282 6.71971C10.6665 7.48142 10.6665 8.71615 11.4282 9.47883L11.5121 9.56173",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M9.56173 11.5123L9.47786 11.4294C8.71615 10.6668 7.48142 10.6668 6.71971 11.4294L2.85265 15.2955C1.71546 16.4337 1.71546 18.2955 2.85265 19.4337L4.56723 21.1473C5.70443 22.2855 7.56725 22.2855 8.70444 21.1473L12.5715 17.2812C13.3332 16.5185 13.3332 15.2838 12.5715 14.5221L12.4876 14.4382",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M8.20728 15.7929L15.7922 8.20703",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};
Link.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Link };
var Logo = function Logo(props) {
  return /*#__PURE__*/_jsx("svg", {
    ...props,
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22 8.88174L19.7695 5.11652L14.2297 8.23391V2H9.76856V8.23304L4.23055 5.11652L2 8.88174L7.53801 12L2 15.1165L4.23055 18.8817L9.76856 15.7643V22H14.2297V15.7643L19.7695 18.8817L22 15.1165L16.4602 12L22 8.88174Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};
Logo.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Logo };
var Unlink = function Unlink(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      d: "M7.1533 5.25184L5.41656 3.43359",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M9.81781 4.27281V2",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M6.2629 8.36377H4.09198",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M11.0608 17.9794L8.10573 21.0713C6.92302 22.3096 4.99004 22.3096 3.80732 21.0713L2.88685 20.1077C1.70414 18.8703 1.70414 16.8448 2.88685 15.6084L5.84103 12.5146",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M14.9462 8.36377H18.8539C20.5255 8.36377 22 9.86564 22 11.6157V13.434C22 15.1831 20.5029 16.5459 18.833 16.5459H14.9462",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};
Unlink.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Unlink };
var Menu = function Menu(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("line", {
      x1: "2.75",
      y1: "3.25",
      x2: "21.25",
      y2: "3.25",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round"
    }), /*#__PURE__*/_jsx("line", {
      x1: "2.75",
      y1: "12.25",
      x2: "21.25",
      y2: "12.25",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round"
    }), /*#__PURE__*/_jsx("line", {
      x1: "2.75",
      y1: "21.25",
      x2: "21.25",
      y2: "21.25",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round"
    })]
  });
};
Menu.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Menu };
var Logout = function Logout(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      d: "M15.6707 4.81299C18.9777 6.19269 21.3021 9.4575 21.3021 13.2629C21.3021 18.3171 17.2038 22.414 12.151 22.414C7.09685 22.414 3 18.3171 3 13.2629C3 9.47439 5.30466 6.22084 8.58918 4.8327",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M12.151 2V11.1511",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};
Logout.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Logout };
var Support = function Support(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      d: "M7.84271 13.3045H2.00006V10.6958H7.8288",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M13.3049 16.144V21.9997H10.6962V16.144",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M16.1445 10.6958H22.0002V13.3045H16.1306",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M10.6962 7.84091V2H13.3049V7.85656",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.3484 12.0002C16.3484 14.4002 14.4014 16.3481 12.0005 16.3481C9.59788 16.3481 7.65265 14.4002 7.65265 12.0002C7.65265 9.59844 9.59788 7.65234 12.0005 7.65234C14.4014 7.65234 16.3484 9.59844 16.3484 12.0002V12.0002Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M13.3049 2.96143C17.3032 3.5336 20.4658 6.69624 21.038 10.6963",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M2.96173 10.6958C3.53391 6.69575 6.69654 3.53399 10.6966 2.96094",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M10.6961 21.0378C6.69611 20.4673 3.53435 17.303 2.9613 13.3047",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M21.0375 13.3047C20.4662 17.303 17.3027 20.4665 13.3044 21.0378",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};
Support.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Support };
var Trash = function Trash(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.8182 19.9997C18.8182 21.1043 17.9228 21.9997 16.8182 21.9997H6.27277C5.1682 21.9997 4.27277 21.1043 4.27277 19.9997V4.6084H18.8182V19.9997Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.1818 4.6087H7.90906V2H15.1818V4.6087Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M2 4.6084H22",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M7.90906 7.65234V18.0871",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M11.5454 7.65234V18.0871",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M15.1818 7.65234V18.0871",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};
Trash.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Trash };
var Move = function Move(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("circle", {
      cx: "3.42857",
      cy: "3.42857",
      r: "1.42857",
      fill: "currentColor"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "9.14293",
      cy: "3.42857",
      r: "1.42857",
      fill: "currentColor"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "14.857",
      cy: "3.42857",
      r: "1.42857",
      fill: "currentColor"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "20.5714",
      cy: "3.42857",
      r: "1.42857",
      fill: "currentColor"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "3.42857",
      cy: "9.14293",
      r: "1.42857",
      fill: "currentColor"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "9.14293",
      cy: "9.14293",
      r: "1.42857",
      fill: "currentColor"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "14.857",
      cy: "9.14293",
      r: "1.42857",
      fill: "currentColor"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "20.5714",
      cy: "9.14293",
      r: "1.42857",
      fill: "currentColor"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "3.42857",
      cy: "14.8573",
      r: "1.42857",
      fill: "currentColor"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "9.14293",
      cy: "14.8573",
      r: "1.42857",
      fill: "currentColor"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "14.857",
      cy: "14.8573",
      r: "1.42857",
      fill: "currentColor"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "20.5714",
      cy: "14.8573",
      r: "1.42857",
      fill: "currentColor"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "3.42857",
      cy: "20.5716",
      r: "1.42857",
      fill: "currentColor"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "9.14293",
      cy: "20.5716",
      r: "1.42857",
      fill: "currentColor"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "14.857",
      cy: "20.5716",
      r: "1.42857",
      fill: "currentColor"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "20.5714",
      cy: "20.5716",
      r: "1.42857",
      fill: "currentColor"
    })]
  });
};
Move.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Move };
var MoveVertical = function MoveVertical(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      d: "M10.8691 1V23",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M8 20.1304L10.869 23.0004L13.738 20.1304",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M13.7382 3.87L10.8692 1L8.00018 3.87",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};
MoveVertical.defaultProps = {
  width: "22",
  height: "24",
  viewBox: "0 0 22 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { MoveVertical };
var MoveDirections = function MoveDirections(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      d: "M12 1V23",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M23 12H1",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M3.86912 9.13037L1.00012 12.0004L3.86912 14.8704",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M9.13092 20.1304L11.9999 23.0004L14.8689 20.1304",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M20.1309 14.8699L22.9999 11.9999L20.1309 9.12988",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M14.8691 3.87L12.0001 1L9.1311 3.87",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};
MoveDirections.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { MoveDirections };
var Duplicate = function Duplicate(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      d: "M16.7826 7.21729H22V21.9999H7.21741V16.7825",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2 2H16.7826V16.7826H2V2Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};
Duplicate.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Duplicate };
var Locked = function Locked(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.9412 14.7942C11.9412 15.0369 11.7435 15.2354 11.5 15.2354C11.2565 15.2354 11.0588 15.0369 11.0588 14.7942C11.0588 14.5498 11.2565 14.353 11.5 14.353C11.7435 14.353 11.9412 14.5498 11.9412 14.7942V14.7942Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M11.5 15.2354V17.8824",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19 10.9409C19 10.3886 18.5523 9.94092 18 9.94092H5C4.44772 9.94092 4 10.3886 4 10.9409V21.2939C4 21.8461 4.44772 22.2939 5 22.2939H18C18.5523 22.2939 19 21.8461 19 21.2939V10.9409Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.64709 6.85294C6.64709 4.17235 8.81945 2 11.5 2C14.1806 2 16.353 4.17235 16.353 6.85294V9.94118H6.64709V6.85294V6.85294Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinejoin: "round"
    })]
  });
};
Locked.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Locked };
var Unlocked = function Unlocked(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.9412 14.7942C11.9412 15.0369 11.7435 15.2354 11.5 15.2354C11.2565 15.2354 11.0588 15.0369 11.0588 14.7942C11.0588 14.5498 11.2565 14.353 11.5 14.353C11.7435 14.353 11.9412 14.5498 11.9412 14.7942V14.7942Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M11.5 15.2354V17.8824",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19 10.9414C19 10.3891 18.5523 9.94141 18 9.94141H5C4.44772 9.94141 4 10.3891 4 10.9414V21.2943C4 21.8466 4.44772 22.2943 5 22.2943H18C18.5523 22.2943 19 21.8466 19 21.2943V10.9414Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M6.64709 6.85294C6.64709 4.17235 8.81945 2 11.5 2C14.1797 2 16.353 4.17235 16.353 6.85294V9.94118",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinejoin: "round"
    })]
  });
};
Unlocked.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Unlocked };
var Attachment = function Attachment(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.7826 22H5V2H14.5652L19.7826 7.21739V22Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M14.5652 2V7.21739H19.7826",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("line", {
      x1: "12.7065",
      y1: "8.95654",
      x2: "12.7065",
      y2: "16.7826",
      stroke: "currentColor",
      strokeWidth: "1.5"
    }), /*#__PURE__*/_jsx("line", {
      x1: "8.47833",
      y1: "12.5542",
      x2: "16.3044",
      y2: "12.5542",
      stroke: "currentColor",
      strokeWidth: "1.5"
    })]
  });
};
Attachment.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Attachment };
var Calendar = function Calendar(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      d: "M5.47826 3.73926H4C2.89543 3.73926 2 4.63469 2 5.73926V20.0001C2 21.1047 2.89543 22.0001 4 22.0001H20C21.1046 22.0001 22 21.1047 22 20.0001V5.73926C22 4.63469 21.1046 3.73926 20 3.73926H18.5217",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.08697 4.17391C8.08697 4.89429 7.50299 5.47826 6.78262 5.47826V5.47826C6.06225 5.47826 5.47827 4.89428 5.47827 4.17391V3.30435C5.47827 2.58398 6.06225 2 6.78262 2V2C7.50299 2 8.08697 2.58398 8.08697 3.30435V4.17391Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.5218 4.17391C18.5218 4.89429 17.9378 5.47826 17.2174 5.47826V5.47826C16.4971 5.47826 15.9131 4.89428 15.9131 4.17391V3.30435C15.9131 2.58398 16.4971 2 17.2174 2V2C17.9378 2 18.5218 2.58398 18.5218 3.30435V4.17391Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M8.08691 3.73926H15.913",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M2 8.08691H22",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M8.56519 9.82617V20.261",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M15.9131 9.82617V20.261",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M3.73914 15.0435H20.2609",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};
Calendar.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Calendar };
var Download = function Download(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      d: "M22.0007 17.6528V19.392C22.0007 20.832 20.8325 22.0002 19.3925 22.0002H4.60833C3.16737 22.0002 2.00006 20.832 2.00006 19.392V17.6528",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M12.0005 17.5532V2",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M18.3644 11.1895L12.0006 17.5533L5.63672 11.1895",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};
Download.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Download };
var Gift = function Gift(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22 10.333C22 10.8853 21.5523 11.333 21 11.333H3C2.44772 11.333 2 10.8853 2 10.333V8.77734C2 8.22506 2.44772 7.77734 3 7.77734H21C21.5523 7.77734 22 8.22506 22 8.77734V10.333Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21.1304 21.9999H2.86957V11.333H21.1304V21.9999Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M8.95636 7.77734V21.9999",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M15.0436 21.9999V7.77734",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.9191 5.79364C16.0696 6.6621 12 7.67901 12 7.67901C12 7.67901 12.9948 3.51803 13.8443 2.65135C14.693 1.78288 16.0696 1.78288 16.9191 2.65135C17.7678 3.51803 17.7678 4.92517 16.9191 5.79364V5.79364Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.08063 5.79364C7.92933 6.6621 11.9998 7.67901 11.9998 7.67901C11.9998 7.67901 11.0041 3.51803 10.1554 2.65135C9.30585 1.78288 7.92933 1.78288 7.08063 2.65135C6.23194 3.51803 6.23107 4.92517 7.08063 5.79364V5.79364Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};
Gift.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Gift };
var Info = function Info(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22 12C22 17.5227 17.5218 22 12 22C6.47636 22 2 17.5227 2 12C2 6.47727 6.47636 2 12 2C17.5218 2 22 6.47727 22 12V12Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M10 17H14",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M11 11H12V17",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.5 7C11.223 7 11 7.225 11 7.5C11 7.777 11.223 8 11.5 8C11.775 8 12 7.777 12 7.5C12 7.225 11.775 7 11.5 7V7Z",
      fill: "currentColor",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinejoin: "round"
    })]
  });
};
Info.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Info };
var Upload = function Upload(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      d: "M22.0002 17.6528V19.3919C22.0002 20.8319 20.832 22.0001 19.392 22.0001H4.6082C3.16728 22.0001 2 20.8319 2 19.3919V17.6528",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M12 2V17.5529",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M5.63623 8.36369L11.9999 2L18.3636 8.36369",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};
Upload.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Upload };
var Video = function Video(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.95654 15.7392V7.91309L16.7826 11.8261L8.95654 15.7392Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22 14.8694C22 16.7825 20.4348 18.3477 18.5217 18.3477H5.47826C3.56522 18.3477 2 16.7825 2 14.8694V8.78246C2 6.87029 3.56522 5.3042 5.47826 5.3042H18.5217C20.4348 5.3042 22 6.87029 22 8.78246V14.8694V14.8694Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};
Video.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Video };
var Spinner = function Spinner(props) {
  return /*#__PURE__*/_jsx("svg", {
    ...props,
    children: /*#__PURE__*/_jsx("path", {
      fill: "currentColor",
      d: "M25,5A20.14,20.14,0,0,1,45,22.88a2.51,2.51,0,0,0,2.49,2.26h0A2.52,2.52,0,0,0,50,22.33a25.14,25.14,0,0,0-50,0,2.52,2.52,0,0,0,2.5,2.81h0A2.51,2.51,0,0,0,5,22.88,20.14,20.14,0,0,1,25,5Z",
      children: /*#__PURE__*/_jsx("animateTransform", {
        attributeName: "transform",
        type: "rotate",
        from: "0 25 25",
        to: "360 25 25",
        dur: "0.6s",
        repeatCount: "indefinite"
      })
    })
  });
};
Spinner.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "50",
  height: "50",
  viewBox: "0 0 50 50",
  width: "1em",
  height: "1em"
};
export { Spinner };
var ArrowDown = function ArrowDown(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("defs", {}), /*#__PURE__*/_jsx("path", {
      fill: "currentColor",
      d: "M14 0L7 7 0 0"
    })]
  });
};
ArrowDown.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 7",
  width: "1em",
  height: "1em"
};
export { ArrowDown };
var MarginTop = function MarginTop(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("rect", {
      y: "20",
      width: "24",
      height: "4",
      rx: "1",
      fill: "currentColor"
    }), /*#__PURE__*/_jsx("path", {
      d: "M8 6.34766L12.3478 1.99983L16.6957 6.34766",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M12.3478 2L12.3478 16.5",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};
MarginTop.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { MarginTop };
var MarginRight = function MarginRight(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_9377_13491)",
      children: [/*#__PURE__*/_jsx("rect", {
        x: "4",
        width: "24",
        height: "4",
        rx: "1",
        transform: "rotate(90 4 0)",
        fill: "currentColor"
      }), /*#__PURE__*/_jsx("path", {
        d: "M17.6522 8L22 12.3478L17.6522 16.6957",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_jsx("path", {
        d: "M22 12.3477L7.5 12.3477",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_9377_13491",
        children: /*#__PURE__*/_jsx("rect", {
          width: "24",
          height: "24",
          fill: "currentColor",
          transform: "translate(24) rotate(90)"
        })
      })
    })]
  });
};
MarginRight.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { MarginRight };
var MarginBottom = function MarginBottom(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_9377_13479)",
      children: [/*#__PURE__*/_jsx("rect", {
        x: "24",
        y: "4",
        width: "24",
        height: "4",
        rx: "1",
        transform: "rotate(-180 24 4)",
        fill: "currentColor"
      }), /*#__PURE__*/_jsx("path", {
        d: "M16 17.6523L11.6522 22.0002L7.30435 17.6523",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_jsx("path", {
        d: "M11.6523 22L11.6523 7.5",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_9377_13479",
        children: /*#__PURE__*/_jsx("rect", {
          width: "24",
          height: "24",
          fill: "currentColor",
          transform: "translate(24 24) rotate(-180)"
        })
      })
    })]
  });
};
MarginBottom.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { MarginBottom };
var MarginLeft = function MarginLeft(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_9377_13485)",
      children: [/*#__PURE__*/_jsx("rect", {
        x: "20",
        y: "24",
        width: "24",
        height: "4",
        rx: "1",
        transform: "rotate(-90 20 24)",
        fill: "currentColor"
      }), /*#__PURE__*/_jsx("path", {
        d: "M6.34784 16L2.00001 11.6522L6.34784 7.30435",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_jsx("path", {
        d: "M2 11.6523L16.5 11.6523",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_9377_13485",
        children: /*#__PURE__*/_jsx("rect", {
          width: "24",
          height: "24",
          fill: "currentColor",
          transform: "translate(0 24) rotate(-90)"
        })
      })
    })]
  });
};
MarginLeft.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { MarginLeft };
var Width = function Width(props) {
  return /*#__PURE__*/_jsx("svg", {
    ...props,
    children: /*#__PURE__*/_jsx("path", {
      d: "M1 7.5H39M1 7.5L7.54444 14M1 7.5L7.54444 1M39 7.5L32.4556 14M39 7.5L32.4556 1",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};
Width.defaultProps = {
  width: "40",
  height: "15",
  viewBox: "0 0 40 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Width };
var Feedback = function Feedback(props) {
  return /*#__PURE__*/_jsx("svg", {
    ...props,
    children: /*#__PURE__*/_jsx("path", {
      d: "M18.8182 15.8454V15.8454C19.5718 15.8454 20.1818 16.4563 20.1818 17.209C20.1818 17.9636 19.5718 18.5727 18.8182 18.5727H17.9091C18.6627 18.5727 19.2727 19.1836 19.2727 19.9363C19.2727 20.6909 18.6627 21.3 17.9091 21.3H12C8.36364 21.3 9.27273 19.4818 2 19.4818V11.3H4.72727C7.90909 11.3 11.5455 8.37177 11.5455 4.02723C11.5455 2.58995 14.2727 2.40814 14.2727 5.13541C14.2727 6.95359 13.3636 10.3909 13.3636 10.3909H20.6364C21.39 10.3909 22 11.0018 22 11.7545C22 12.509 21.39 13.1181 20.6364 13.1181H19.7273C20.4809 13.1181 21.0909 13.729 21.0909 14.4818C21.0909 15.2363 20.4809 15.8454 19.7273 15.8454H18.8182",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};
Feedback.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Feedback };
var LetterSpacing = function LetterSpacing(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      d: "M20.8889 22L20.8889 2",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M2 22L2 2",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M7.8807 16.6466L9.01864 13.4427H13.5925L14.7304 16.6466H16.1667L12.0126 5.3335H10.5985L6.44446 16.6466H7.8807ZM9.44951 12.2274L11.2614 7.12327H11.3498L13.1616 12.2274H9.44951Z",
      fill: "currentColor"
    })]
  });
};
LetterSpacing.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { LetterSpacing };
var LineHeight = function LineHeight(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      d: "M2 20.8892H22",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M2 2H22",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M8.99178 16.6466L10.1297 13.4427H14.7036L15.8415 16.6466H17.2778L13.1237 5.3335H11.7096L7.55554 16.6466H8.99178ZM10.5606 12.2274L12.3725 7.12327H12.4608L14.2727 12.2274H10.5606Z",
      fill: "currentColor"
    })]
  });
};
LineHeight.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { LineHeight };
var ThumbsUp = function ThumbsUp(props) {
  return /*#__PURE__*/_jsx("svg", {
    ...props,
    children: /*#__PURE__*/_jsx("path", {
      d: "M26.4806 20.7454V20.7454C27.6391 20.7454 28.5768 21.6845 28.5768 22.8416C28.5768 24.0014 27.6391 24.9377 26.4806 24.9377H25.0832C26.2417 24.9377 27.1794 25.8768 27.1794 27.0338C27.1794 28.1937 26.2417 29.1299 25.0832 29.1299H16C10.4103 29.1299 11.8078 26.3351 0.628418 26.3351V13.7584H4.82067C9.71163 13.7584 15.3013 9.25727 15.3013 2.57901C15.3013 0.369693 19.4936 0.0902094 19.4936 4.28246C19.4936 7.0773 18.0961 12.3609 18.0961 12.3609H29.2755C30.4339 12.3609 31.3716 13.3 31.3716 14.4571C31.3716 15.6169 30.4339 16.5532 29.2755 16.5532H27.8781C29.0365 16.5532 29.9742 17.4923 29.9742 18.6493C29.9742 19.8092 29.0365 20.7454 27.8781 20.7454H26.4806",
      fillRule: "evenodd",
      fill: "currentColor"
    })
  });
};
ThumbsUp.defaultProps = {
  width: "32",
  height: "30",
  viewBox: "0 0 32 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { ThumbsUp };
var ThumbsDown = function ThumbsDown(props) {
  return /*#__PURE__*/_jsx("svg", {
    ...props,
    children: /*#__PURE__*/_jsx("g", {
      id: "Page-1",
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/_jsx("g", {
        id: "thumbsup",
        transform: "translate(16.000000, 14.500000) rotate(-180.000000) translate(-16.000000, -14.500000) translate(0.000000, -0.000000)",
        fill: "currentColor",
        children: /*#__PURE__*/_jsx("path", {
          d: "M26.4806,19.7454 L26.4806,19.7454 C27.6391,19.7454 28.5768,20.6845 28.5768,21.8416 C28.5768,23.0014 27.6391,23.9377 26.4806,23.9377 L25.0832,23.9377 C26.2417,23.9377 27.1794,24.8768 27.1794,26.0338 C27.1794,27.1937 26.2417,28.1299 25.0832,28.1299 L16,28.1299 C10.4103,28.1299 11.8078,25.3351 0.628418,25.3351 L0.628418,12.7584 L4.82067,12.7584 C9.71163,12.7584 15.3013,8.25727 15.3013,1.57901 C15.3013,-0.630307 19.4936,-0.9097906 19.4936,3.28246 C19.4936,6.0773 18.0961,11.3609 18.0961,11.3609 L29.2755,11.3609 C30.4339,11.3609 31.3716,12.3 31.3716,13.4571 C31.3716,14.6169 30.4339,15.5532 29.2755,15.5532 L27.8781,15.5532 C29.0365,15.5532 29.9742,16.4923 29.9742,17.6493 C29.9742,18.8092 29.0365,19.7454 27.8781,19.7454 L26.4806,19.7454",
          id: "Path"
        })
      })
    })
  });
};
ThumbsDown.defaultProps = {
  width: "32px",
  height: "29px",
  viewBox: "0 0 32 29",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "1em",
  height: "1em"
};
export { ThumbsDown };
var HeartRound = function HeartRound(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21 11.5C21 16.7465 16.7473 21 11.5 21C6.2527 21 2 16.7465 2 11.5C2 6.2527 6.2527 2 11.5 2C16.7473 2 21 6.2527 21 11.5V11.5Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.5 16.4563C11.5 16.4563 16.0435 13.152 16.0435 10.7051C16.0435 7.8807 12.3261 6.9877 11.5 10.4234C10.6739 6.9877 6.95654 7.8807 6.95654 10.7051C6.95654 13.152 11.5 16.4563 11.5 16.4563Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};
HeartRound.defaultProps = {
  width: "23",
  height: "23",
  viewBox: "0 0 23 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { HeartRound };
var Integrations = function Integrations(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.5814 13.8019L2 8.67627V16.8773L11.5814 22.0029V13.8019V13.8019Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21.9998 8.67578L11.5473 13.8014V22.0024L21.9998 16.8768V8.67578V8.67578Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.6624 9.16024C14.6624 10.009 13.4918 10.6979 12.0493 10.6979C10.606 10.6979 9.43622 10.009 9.43622 9.16024C9.43622 8.31144 10.606 7.62256 12.0493 7.62256C13.4918 7.62256 14.6624 8.31144 14.6624 9.16024V9.16024Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.6624 3.53769C14.6624 4.38649 13.4918 5.07537 12.0493 5.07537C10.606 5.07537 9.43622 4.38649 9.43622 3.53769C9.43622 2.68888 10.606 2 12.0493 2C13.4918 2 14.6624 2.68888 14.6624 3.53769V3.53769Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20.764 6.62265C20.764 7.47145 19.5933 8.16033 18.1509 8.16033C16.7076 8.16033 15.5378 7.47145 15.5378 6.62265C15.5378 5.77384 16.7076 5.08496 18.1509 5.08496C19.5933 5.08496 20.764 5.77384 20.764 6.62265V6.62265Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.94907 6.62265C8.94907 7.47145 7.77839 8.16033 6.33595 8.16033C4.89264 8.16033 3.72284 7.47145 3.72284 6.62265C3.72284 5.77384 4.89264 5.08496 6.33595 5.08496C7.77839 5.08496 8.94907 5.77384 8.94907 6.62265V6.62265Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M4.24205 7.50488L2 8.652",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M10.0603 4.5376L8.18323 5.49814",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M16.095 5.62115L13.9749 4.5376",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M22.0016 8.62256L19.9982 7.62256",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};
Integrations.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Integrations };
var Rotate = function Rotate(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      d: "M22 8.90967L19.2726 13.0008L16.0906 9.36423",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M19.2668 13.001C19.7087 7.18251 15.7212 3.18142 10.9528 3.00596C6.18715 2.83049 2.1797 6.55339 2.00605 11.3191C1.82786 16.0865 5.55167 20.0931 10.3182 20.2676",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};
Rotate.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Rotate };
var Home = function Home(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      d: "M3.86963 10.5V23.0833H9.60876V15.5H14.3914V23.0833H20.1305V10.5",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M1 12.5L12 2.5L23 12.5",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};
Home.defaultProps = {
  width: "24",
  height: "25",
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Home };
var Team = function Team(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      d: "M4.65219 7.37451V8.826L2.00279 9.58252C1.45183 9.74113 1 10.339 1 10.913V11.4347H6.73916",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M7.78264 7.3418V8.82563L10.431 9.58215C10.983 9.74076 11.4348 10.3387 11.4348 10.9126V11.4343H5.69568",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.34787 4.41323C9.34787 6.29776 7.94543 7.82646 6.21742 7.82646C4.48837 7.82646 3.08698 6.29776 3.08698 4.41323C3.08698 2.52766 4.48837 1 6.21742 1C7.94543 1 9.34787 2.52766 9.34787 4.41323V4.41323Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M18.2175 7.37451V8.826L15.5681 9.58252C15.0171 9.74113 14.5653 10.339 14.5653 10.913V11.4347H20.3045",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M21.3479 7.3584V8.82554L23.9963 9.5831C24.5483 9.74067 25.0001 10.3386 25.0001 10.9125V11.4342H19.2609",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22.9131 4.41323C22.9131 6.29776 21.5107 7.82646 19.7827 7.82646C18.0536 7.82646 16.6522 6.29776 16.6522 4.41323C16.6522 2.52766 18.0536 1 19.7827 1C21.5107 1 22.9131 2.52766 22.9131 4.41323V4.41323Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M11.4348 20.9399V22.3914L8.78544 23.148C8.23448 23.3066 7.78265 23.9045 7.78265 24.4784V25.0001H13.5218",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M14.5653 20.9399V22.3914L17.2137 23.148C17.7657 23.3066 18.2175 23.9045 18.2175 24.4784V25.0001H12.4783",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.1305 17.9787C16.1305 19.8632 14.7281 21.3919 13.0001 21.3919C11.271 21.3919 9.86963 19.8632 9.86963 17.9787C9.86963 16.0931 11.271 14.5654 13.0001 14.5654C14.7281 14.5654 16.1305 16.0931 16.1305 17.9787V17.9787Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M4.5 14L6.63019 16.13",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M21.2608 13.8694L19 16.1302",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};
Team.defaultProps = {
  width: "26",
  height: "26",
  viewBox: "0 0 26 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Team };
var Alert = function Alert(props) {
  return /*#__PURE__*/_jsx("svg", {
    ...props,
    children: /*#__PURE__*/_jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M14.545 4.17a1.5 1.5 0 0 1-.94-1.179C13.472 2.092 12.757 1.5 12 1.5c-.76 0-1.476.595-1.608 1.49a1.5 1.5 0 0 1-.94 1.18C6.665 5.254 4.63 8.08 4.63 11.454v6c0 .622-.117 1.221-.332 1.773h15.403a4.89 4.89 0 0 1-.331-1.773v-6c0-3.372-2.038-6.2-4.825-7.284Zm6.822 15.057c.557.903 1.527 1.5 2.633 1.5H0c1.103 0 2.074-.597 2.632-1.5.315-.51.498-1.12.498-1.773v-6c0-3.981 2.406-7.37 5.778-8.682C9.138 1.203 10.435 0 12 0c1.565 0 2.857 1.203 3.089 2.772 3.371 1.312 5.78 4.7 5.78 8.682v6c0 .654.183 1.262.498 1.773ZM11.478 22.5c.838 0 1.63-.73 1.63-1.773h1.5c0 1.808-1.402 3.273-3.13 3.273-1.73 0-3.13-1.465-3.13-3.273h1.5c0 1.044.79 1.773 1.63 1.773Z",
      clipRule: "evenodd"
    })
  });
};
Alert.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  width: "1em",
  height: "1em"
};
export { Alert };
var AlertFilled = function AlertFilled(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      d: "M14.3467 2.88156C14.3861 3.14817 14.5655 3.37316 14.8166 3.47092C17.8959 4.66952 20.1196 7.77753 20.1196 11.4545V17.4545C20.1196 18.4021 20.4386 19.2829 20.977 19.9773H3.02204C3.56078 19.283 3.88043 18.4023 3.88043 17.4545V11.4545C3.88043 7.77699 6.10045 4.66936 9.18016 3.47095C9.4315 3.37314 9.61097 3.14791 9.6502 2.88108C9.83131 1.64909 10.8377 0.75 12 0.75C13.161 0.75 14.1646 1.64781 14.3467 2.88156Z",
      fill: "currentColor",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("mask", {
      id: "path-2-inside-1_9285_13674",
      fill: "currentColor",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.6085 20.7266C14.6085 22.5342 13.2061 23.9993 11.4781 23.9993C9.74696 23.9993 8.34766 22.5342 8.34766 20.7266"
      })
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.6085 20.7266C14.6085 22.5342 13.2061 23.9993 11.4781 23.9993C9.74696 23.9993 8.34766 22.5342 8.34766 20.7266",
      fill: "currentColor"
    }), /*#__PURE__*/_jsx("path", {
      d: "M16.1085 20.7266C16.1085 19.8981 15.437 19.2266 14.6085 19.2266C13.7801 19.2266 13.1085 19.8981 13.1085 20.7266H16.1085ZM9.84766 20.7266C9.84766 19.8981 9.17608 19.2266 8.34766 19.2266C7.51923 19.2266 6.84766 19.8981 6.84766 20.7266H9.84766ZM13.1085 20.7266C13.1085 21.769 12.3158 22.4993 11.4781 22.4993V25.4993C14.0963 25.4993 16.1085 23.2994 16.1085 20.7266H13.1085ZM11.4781 22.4993C10.6382 22.4993 9.84766 21.77 9.84766 20.7266H6.84766C6.84766 23.2984 8.85576 25.4993 11.4781 25.4993V22.4993Z",
      fill: "currentColor",
      mask: "url(#path-2-inside-1_9285_13674)"
    })]
  });
};
AlertFilled.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { AlertFilled };
var Magic = function Magic(props) {
  return /*#__PURE__*/_jsx("svg", {
    ...props,
    children: /*#__PURE__*/_jsx("path", {
      d: "M19.9881 7.34653L18.9603 5.11718L16.725 4.08348L18.9603 3.04978L19.9881 0.814453L21.0218 3.04978L23.2571 4.08348L21.0218 5.11718L19.9881 7.34653ZM8.03968 7.34653L7.01195 5.11718L4.77663 4.08348L7.01195 3.04978L8.03968 0.814453L9.07335 3.04978L11.3087 4.08348L9.07335 5.11718L8.03968 7.34653ZM19.9881 19.3069L18.9603 17.0715L16.725 16.0378L18.9603 15.0101L19.9881 12.7748L21.0218 15.0101L23.2571 16.0378L21.0218 17.0715L19.9881 19.3069ZM5.09403 21.9987L2.09078 18.9895C1.86286 18.7616 1.7489 18.488 1.7489 18.1688C1.7489 17.8496 1.86285 17.5761 2.09075 17.3482L13.2587 6.19218C13.4826 5.96826 13.7542 5.8563 14.0734 5.8563C14.3926 5.8563 14.6641 5.96826 14.8881 6.19218L17.9033 9.18945C18.1312 9.41735 18.2451 9.6919 18.2451 10.0131C18.2451 10.3343 18.1312 10.6089 17.9033 10.8368L6.73533 22.0107C6.51141 22.2346 6.23786 22.3445 5.91468 22.3406C5.59149 22.3366 5.31794 22.2226 5.09403 21.9987Z",
      fill: "currentColor"
    })
  });
};
Magic.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Magic };
var StarFilled = function StarFilled(props) {
  return /*#__PURE__*/_jsx("svg", {
    ...props,
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.5 1L15.5 9.5H24L17 15L20 24L12.5 18.5L5 24L8 15L1 9.5H9.5L12.5 1V1Z",
      fill: "currentColor",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinejoin: "round"
    })
  });
};
StarFilled.defaultProps = {
  width: "25",
  height: "25",
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { StarFilled };
var StarOutline = function StarOutline(props) {
  return /*#__PURE__*/_jsx("svg", {
    ...props,
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.5 1L15.5 9.5H24L17 15L20 24L12.5 18.5L5 24L8 15L1 9.5H9.5L12.5 1V1Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinejoin: "round"
    })
  });
};
StarOutline.defaultProps = {
  width: "25",
  height: "25",
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { StarOutline };
var Stars = function Stars(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      d: "M10.7783 7.97974L11.8774 6.04676L13.8872 4.99008L11.8774 3.93267L10.7783 2L9.67918 3.93267L7.66943 4.99008L9.67918 6.04676L10.7783 7.97974Z",
      fill: "currentColor"
    }), /*#__PURE__*/_jsx("path", {
      d: "M19.505 9.83734L17.6494 7.43799L15.7936 9.83734L13.2985 11.6221L15.7936 13.4065L17.6494 15.8065L19.505 13.4065L22 11.6221L19.505 9.83734Z",
      fill: "currentColor"
    }), /*#__PURE__*/_jsx("path", {
      d: "M7.94378 10.5669L5.84213 14.2626L2 16.2839L5.84213 18.3047L7.94378 21.9999L10.0451 18.3047L13.8872 16.2839L10.0451 14.2626L7.94378 10.5669Z",
      fill: "currentColor"
    })]
  });
};
Stars.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Stars };
var TopAlign = function TopAlign(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_9374_13455)",
      children: [/*#__PURE__*/_jsx("line", {
        x1: "24",
        y1: "1",
        x2: "-8.74228e-08",
        y2: "0.999998",
        stroke: "currentColor",
        strokeWidth: "2"
      }), /*#__PURE__*/_jsx("rect", {
        x: "16",
        y: "6",
        width: "12",
        height: "8",
        rx: "1",
        transform: "rotate(90 16 6)",
        fill: "currentColor"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_9374_13455",
        children: /*#__PURE__*/_jsx("rect", {
          width: "24",
          height: "24",
          fill: "currentColor",
          transform: "translate(24) rotate(90)"
        })
      })
    })]
  });
};
TopAlign.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { TopAlign };
var VerticalCenter = function VerticalCenter(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_9374_13458)",
      children: [/*#__PURE__*/_jsx("line", {
        x1: "24",
        y1: "12",
        x2: "-8.74228e-08",
        y2: "12",
        stroke: "currentColor",
        strokeWidth: "2"
      }), /*#__PURE__*/_jsx("rect", {
        x: "16",
        y: "6",
        width: "12",
        height: "8",
        rx: "1",
        transform: "rotate(90 16 6)",
        fill: "currentColor"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_9374_13458",
        children: /*#__PURE__*/_jsx("rect", {
          width: "24",
          height: "24",
          fill: "currentColor",
          transform: "translate(24) rotate(90)"
        })
      })
    })]
  });
};
VerticalCenter.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { VerticalCenter };
var BottomAlign = function BottomAlign(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_9374_13461)",
      children: [/*#__PURE__*/_jsx("line", {
        x1: "5.56363e-08",
        y1: "23",
        x2: "24",
        y2: "23",
        stroke: "currentColor",
        strokeWidth: "2"
      }), /*#__PURE__*/_jsx("rect", {
        x: "8",
        y: "18",
        width: "12",
        height: "8",
        rx: "1",
        transform: "rotate(-90 8 18)",
        fill: "currentColor"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_9374_13461",
        children: /*#__PURE__*/_jsx("rect", {
          width: "24",
          height: "24",
          fill: "currentColor",
          transform: "translate(0 24) rotate(-90)"
        })
      })
    })]
  });
};
BottomAlign.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { BottomAlign };
var AlignLeft = function AlignLeft(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_9374_13446)",
      children: [/*#__PURE__*/_jsx("line", {
        x1: "1",
        y1: "4.37114e-08",
        x2: "0.999999",
        y2: "24",
        stroke: "currentColor",
        strokeWidth: "2"
      }), /*#__PURE__*/_jsx("rect", {
        x: "6",
        y: "8",
        width: "12",
        height: "8",
        rx: "1",
        fill: "currentColor"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_9374_13446",
        children: /*#__PURE__*/_jsx("rect", {
          width: "24",
          height: "24",
          fill: "currentColor"
        })
      })
    })]
  });
};
AlignLeft.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { AlignLeft };
var HorizontalCenter = function HorizontalCenter(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("line", {
      x1: "12",
      y1: "4.37114e-08",
      x2: "12",
      y2: "24",
      stroke: "currentColor",
      strokeWidth: "2"
    }), /*#__PURE__*/_jsx("rect", {
      x: "6",
      y: "8",
      width: "12",
      height: "8",
      rx: "1",
      fill: "currentColor"
    })]
  });
};
HorizontalCenter.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { HorizontalCenter };
var AlignRight = function AlignRight(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("line", {
      x1: "23",
      y1: "4.37114e-08",
      x2: "23",
      y2: "24",
      stroke: "currentColor",
      strokeWidth: "2"
    }), /*#__PURE__*/_jsx("rect", {
      x: "6",
      y: "8",
      width: "12",
      height: "8",
      rx: "1",
      fill: "currentColor"
    })]
  });
};
AlignRight.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { AlignRight };
var Check = function Check(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      d: "M7 12.2331L10.3835 15.6165L17 9",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeMiterlimit: "10",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "12",
      cy: "12",
      r: "10",
      stroke: "currentColor",
      strokeWidth: "1.5"
    })]
  });
};
Check.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Check };
var CheckFilled = function CheckFilled(props) {
  return /*#__PURE__*/_jsx("svg", {
    ...props,
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM17.5303 9.53033C17.8232 9.23744 17.8232 8.76256 17.5303 8.46967C17.2374 8.17678 16.7626 8.17678 16.4697 8.46967L10.3835 14.5559L7.53033 11.7028C7.23744 11.4099 6.76256 11.4099 6.46967 11.7028C6.17678 11.9956 6.17678 12.4705 6.46967 12.7634L9.85313 16.1469C10.146 16.4398 10.6209 16.4398 10.9138 16.1469L17.5303 9.53033Z",
      fill: "currentColor"
    })
  });
};
CheckFilled.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { CheckFilled };
var File = function File(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18 24H1V1H12L18 7V24V24Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M12 1V7H18",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};
File.defaultProps = {
  width: "19",
  height: "25",
  viewBox: "0 0 19 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { File };
var Spacing = function Spacing(props) {
  return /*#__PURE__*/_jsx("svg", {
    ...props,
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22 20H2V4H22V20Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeDasharray: "5 5"
    })
  });
};
Spacing.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Spacing };
var Flip = function Flip(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      d: "M4 12L21 12",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.4 20.2C5.63119 20.7766 6.03899 22 7 22L17 22C17.961 22 18.3688 20.7766 17.6 20.2L12.6 16.45C12.2444 16.1833 11.7556 16.1833 11.4 16.45L6.4 20.2Z",
      fill: "currentColor"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.4 3.8C5.63119 3.22339 6.03899 2 7 2L17 2C17.961 2 18.3688 3.22339 17.6 3.8L12.6 7.55C12.2444 7.81667 11.7556 7.81667 11.4 7.55L6.4 3.8Z",
      fill: "currentColor"
    })]
  });
};
Flip.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Flip };
var Flop = function Flop(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      d: "M12 4V21",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.8 6.4C3.22339 5.63119 2 6.03899 2 7V17C2 17.961 3.22339 18.3688 3.8 17.6L7.55 12.6C7.81667 12.2444 7.81667 11.7556 7.55 11.4L3.8 6.4Z",
      fill: "currentColor"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20.2 6.4C20.7766 5.63119 22 6.03899 22 7V17C22 17.961 20.7766 18.3688 20.2 17.6L16.45 12.6C16.1833 12.2444 16.1833 11.7556 16.45 11.4L20.2 6.4Z",
      fill: "currentColor"
    })]
  });
};
Flop.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Flop };
var LineThickness = function LineThickness(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("line", {
      x1: "24",
      y1: "25",
      x2: "-8.01375e-08",
      y2: "25",
      stroke: "currentColor",
      strokeWidth: "2"
    }), /*#__PURE__*/_jsx("line", {
      x1: "24",
      y1: "15.0898",
      x2: "-1.60275e-07",
      y2: "15.0898",
      stroke: "currentColor",
      strokeWidth: "4"
    }), /*#__PURE__*/_jsx("line", {
      x1: "24",
      y1: "3",
      x2: "-2.62268e-07",
      y2: "3",
      stroke: "currentColor",
      strokeWidth: "6"
    })]
  });
};
LineThickness.defaultProps = {
  width: "24",
  height: "26",
  viewBox: "0 0 24 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { LineThickness };
var Crop = function Crop(props) {
  return /*#__PURE__*/_jsx("svg", {
    ...props,
    children: /*#__PURE__*/_jsx("path", {
      d: "M17 23V19H7C6.45 19 5.97917 18.8042 5.5875 18.4125C5.19583 18.0208 5 17.55 5 17V7H1V5H5V1H7V17H23V19H19V23H17ZM17 15V7H9V5H17C17.55 5 18.0208 5.19583 18.4125 5.5875C18.8042 5.97917 19 6.45 19 7V15H17Z",
      fill: "currentColor"
    })
  });
};
Crop.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { Crop };
var TopLeftCorner = function TopLeftCorner(props) {
  return /*#__PURE__*/_jsx("svg", {
    ...props,
    children: /*#__PURE__*/_jsx("path", {
      d: "M20 6C18.0667 6 16.25 6.36667 14.55 7.1C12.85 7.83333 11.3667 8.83333 10.1 10.1C8.83333 11.3667 7.83333 12.85 7.1 14.55C6.36667 16.25 6 18.0667 6 20L4 20C4 17.8 4.42083 15.7292 5.2625 13.7875C6.10417 11.8458 7.25 10.15 8.7 8.7C10.15 7.25 11.8458 6.10417 13.7875 5.2625C15.7292 4.42083 17.8 4 20 4L20 6Z",
      fill: "currentColor"
    })
  });
};
TopLeftCorner.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { TopLeftCorner };
var TopRightCorner = function TopRightCorner(props) {
  return /*#__PURE__*/_jsx("svg", {
    ...props,
    children: /*#__PURE__*/_jsx("path", {
      d: "M18 20C18 18.0667 17.6333 16.25 16.9 14.55C16.1667 12.85 15.1667 11.3667 13.9 10.1C12.6333 8.83333 11.15 7.83333 9.45 7.1C7.75 6.36667 5.93333 6 4 6V4C6.2 4 8.27083 4.42083 10.2125 5.2625C12.1542 6.10417 13.85 7.25 15.3 8.7C16.75 10.15 17.8958 11.8458 18.7375 13.7875C19.5792 15.7292 20 17.8 20 20H18Z",
      fill: "currentColor"
    })
  });
};
TopRightCorner.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { TopRightCorner };
var BottomRightCorner = function BottomRightCorner(props) {
  return /*#__PURE__*/_jsx("svg", {
    ...props,
    children: /*#__PURE__*/_jsx("path", {
      d: "M4 18C5.93333 18 7.75 17.6333 9.45 16.9C11.15 16.1667 12.6333 15.1667 13.9 13.9C15.1667 12.6333 16.1667 11.15 16.9 9.45C17.6333 7.75 18 5.93333 18 4L20 4C20 6.2 19.5792 8.27083 18.7375 10.2125C17.8958 12.1542 16.75 13.85 15.3 15.3C13.85 16.75 12.1542 17.8958 10.2125 18.7375C8.27083 19.5792 6.2 20 4 20L4 18Z",
      fill: "currentColor"
    })
  });
};
BottomRightCorner.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { BottomRightCorner };
var BottomLeftCorner = function BottomLeftCorner(props) {
  return /*#__PURE__*/_jsx("svg", {
    ...props,
    children: /*#__PURE__*/_jsx("path", {
      d: "M6 4C6 5.93333 6.36667 7.75 7.1 9.45C7.83333 11.15 8.83333 12.6333 10.1 13.9C11.3667 15.1667 12.85 16.1667 14.55 16.9C16.25 17.6333 18.0667 18 20 18L20 20C17.8 20 15.7292 19.5792 13.7875 18.7375C11.8458 17.8958 10.15 16.75 8.7 15.3C7.25 13.85 6.10417 12.1542 5.2625 10.2125C4.42083 8.27083 4 6.2 4 4L6 4Z",
      fill: "currentColor"
    })
  });
};
BottomLeftCorner.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
};
export { BottomLeftCorner };
